import React, { useState, useEffect, Fragment } from 'react';
import {
  Row,
  Button,
  CardImg,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import {
  Colxx,
  Separator,
} from '../../../../../components/common/CustomBootstrap';
import {
  AxiosAPI,
  getGroupID,
  AxiosStripeAPI,
  getUserID,
} from '../../../../../helpers/AxiosAPI';
import {
  gAPI_Products_List,
  gAPI_Subscription_By_Group_Id,
  postAPI_Create_Subscription,
  gAPI_Users_By_Id,
  putAPI_Update_Subscription,
  gAPI_Group_By_Id,
  postApi_Billing_Details
} from '../../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import ProductListItem from './components/ProductListItem';

function Index({ propertyId, isVoucherEngine }) {
  const [productsList, setProductsList] = useState([]);
  const [cancelPopUp, setPopUp] = useState(false);
  const [selectedSubscription, setSelectedSubscription] = useState({
    stripeCustomerId: '',
    stripeSubscriptionId: '',
    stripeProductId: '',
    stripePriceId: '',
    productId: 0,
    priceId: 1,
    status: 'Active',
    Updater: 'dashboard',
  });

  const [selectedSubscriptionID, setSelectedSubscriptionID] = useState('');
  const [selectedProductID, setSelectedProductID] = useState('');
  const [selectedStripeSubscriptionID, setSelectedStripeSubscriptionID] =
    useState('');
  const [customerID, setcustomerID] = useState('');
  const [selectedProduct, setSelectedProduct] = useState();
  const [productChosen, setproductChosen] = useState(false);
  const [enabledSelection, setEnabledSelection] = useState(false);
  const [loading, setLoading] = useState(true);

  const togglePopUp = () => {
    //console.log(cancelPopUp);
    setPopUp(!cancelPopUp);
  };

  useEffect(() => {
    LoadData();
  }, [propertyId]);

  const LoadData = () => {
    let type = 'Website';
    if (isVoucherEngine) {
      type = 'Voucher';
    }
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Subscription_By_Group_Id}?groupid=${getGroupID()}`,
    })
      .then((subscriptionResponse) => {
        //console.log(subscriptionResponse.data)
        setSelectedSubscriptionID(subscriptionResponse.data.id);
        setcustomerID(subscriptionResponse.data.stripeCustomerId);
        setSelectedProductID(subscriptionResponse.data.stripeProductId);
        setSelectedStripeSubscriptionID(
          subscriptionResponse.data.stripeSubscriptionId
        );

        if (subscriptionResponse.data.productId !== 0) {
          AxiosAPI({
            method: 'get',
            url: `${gAPI_Group_By_Id}/${getGroupID()}`,
          }).then((res) => {
            AxiosAPI({
              methhod: 'get',
              url: `${gAPI_Products_List}?currency=${res.data.billingCurrency}&type=${type}`,
            })
              .then((res) => {
                setProductsList(res.data);
                //console.log(res.data)
                setLoading(false);
              })
              .catch((err) => console.log('err', err));
          });
        } else {
          setLoading(false);
        }
      })
      .catch((err) => console.log('err', err));
  };

  const CheckExistingSubcription = (productsData) => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Subscription_By_Group_Id}?groupid=${getGroupID()}`,
    })
      .then((subscriptionResponse) => {
        // console.log(subscriptionResponse.data)
        setSelectedSubscriptionID(subscriptionResponse.data.id);
        setcustomerID(subscriptionResponse.data.stripeCustomerId);
        setSelectedProductID(subscriptionResponse.data.stripeProductId);
        setSelectedStripeSubscriptionID(
          subscriptionResponse.data.stripeSubscriptionId
        );
      })
      .catch((err) => console.log('err', err));
  };

  const SelectedProduct = (
    e,
    stripeProductId,
    stripePriceId,
    productId,
    priceId
  ) => {
    if (e.target.tagName !== 'A') {
      setSelectedSubscription({
        ...selectedSubscription,
        stripeProductId: stripeProductId,
        stripePriceId: stripePriceId,
        productId: productId,
        priceId: priceId,
      });
      //console.log(productsList)
      const product = productsList.find(
        (elem) => elem.productStripeId == stripeProductId
      );
      //console.log(product)
      setSelectedProduct(product);
      setproductChosen(true);
    }
  };

  const Cancel = () => {
    setproductChosen(false);
  };

  const Subscribe = () => {
    setLoading(true);
    var qs = require('qs');
    if (selectedStripeSubscriptionID === '') {
      var data = qs.stringify({
        customer: customerID,
        'items[0][price]': selectedSubscription.stripePriceId,
        collection_method: 'send_invoice',
        days_until_due: '10',
      });
      AxiosAPI({
        method: 'post',
        url: `${postApi_Billing_Details}?url=v1/subscriptions`,
        data: data,
      }).then((stripeResponse) => {
        //console.log(stripeResponse.data)
        let subscriptionUpdate = {
          stripeCustomerId: customerID,
          stripeSubscriptionId: stripeResponse.data.id,
          stripeProductId: selectedSubscription.stripeProductId,
          stripePriceId: selectedSubscription.stripePriceId,
          productId: selectedSubscription.productId,
          priceId: selectedSubscription.priceId,
          status: 'Active',
          Updater: 'dashboard',
        };
        console.log(subscriptionUpdate);
        AxiosAPI({
          method: 'put',
          url: `${putAPI_Update_Subscription}/${selectedSubscriptionID}`,
          data: subscriptionUpdate,
        })
          .then((res) => {
            console.log(res.data);
            setSelectedProductID(selectedSubscription.stripeProductId);
            setproductChosen(false);
            setLoading(false);
          })
          .catch((err) => console.log('err', err));
      })
        .catch((err) => console.log('err', err));
    } else {
      AxiosAPI({
        method: 'get',
        url: `${postApi_Billing_Details}?url=v1/subscriptions/${selectedStripeSubscriptionID}`,
      }).then((stripeGetResponse) => {
        //console.log(stripeGetResponse.data.items.data[0].id)
        var data = qs.stringify({
          'items[0][id]': stripeGetResponse.data.items.data[0].id,
          'items[0][price]': selectedSubscription.stripePriceId,
          cancel_at_period_end: false,
          proration_behavior: 'create_prorations',
          collection_method: 'send_invoice',
          days_until_due: '10',
        });
        AxiosAPI({
          method: 'post',
          url: `${postApi_Billing_Details}?url=v1/subscriptions/${selectedStripeSubscriptionID}`,
          data: data,
        }).then((stripeResponse) => {
          //console.log(stripeResponse.data)
          let subscriptionUpdate = {
            stripeCustomerId: customerID,
            stripeSubscriptionId: stripeResponse.data.id,
            stripeProductId: selectedSubscription.stripeProductId,
            stripePriceId: selectedSubscription.stripePriceId,
            productId: selectedSubscription.productId,
            priceId: selectedSubscription.priceId,
            status: 'Active',
            Updater: 'dashboard',
          };
          //console.log(subscriptionUpdate)
          AxiosAPI({
            method: 'put',
            url: `${putAPI_Update_Subscription}/${selectedSubscriptionID}`,
            data: subscriptionUpdate,
          })
            .then((res) => {
              // console.log(res.data);
              setSelectedProductID(selectedSubscription.stripeProductId);
              setproductChosen(false);
              setLoading(false);
            })
            .catch((err) => console.log('err', err));
        })
          .catch((err) => console.log('err', err));
      });
    }
  };

  const StripeCustmerPortal = () => {
    var qs = require('qs');
    var data = qs.stringify({
      customer: customerID,
      return_url: window.location.href,
    });
    AxiosAPI({
      method: 'post',
      url: `${postApi_Billing_Details}?url=v1/billing_portal/sessions`,
      data: data,
    }).then((stripeResponse) => {
      window.open(
        stripeResponse.data.url,
        '_blank' // <- This is what makes it open in a new window.
      );
    });
  };

  return (
    <Fragment>
      {!productChosen && (
        <Fragment>
          <Row className="app-row survey-app">
            <Colxx xxs="12">
              <h1>Subscription</h1>
            </Colxx>
          </Row>
          <Separator className="mb-5" />
          {customerID !== '' && (
            <Fragment>
              <Row>
                <Colxx xxs="12" className="mb-2">
                  <Button
                    color="primary"
                    size="xs"
                    onClick={StripeCustmerPortal}
                    style={{ width: '100%', borderRadius: '6px' }}
                  >
                    View Invoices & Payment Methods
                  </Button>
                </Colxx>
              </Row>
              <Row>
                <Colxx xxs="12" className="mb-2">
                  Use the Stripe Customer Portal to add/update Payment Method,
                  Billing Address and view the Billing History.
                </Colxx>
              </Row>
            </Fragment>
          )}

          <div className="equal-height-container mb-5 row">
            {!loading ? (
              productsList.map((item, index) => {
                return (
                  <ProductListItem
                    key={`product_item_${index}`}
                    item={item}
                    SelectedProduct={SelectedProduct}
                    SelectedProductID={selectedProductID}
                    EnabledSelection={enabledSelection}
                    togglePopUp={togglePopUp}
                    voucher={isVoucherEngine}
                  />
                );
              })
            ) : (
              <div className="loading" />
            )}
          </div>
        </Fragment>
      )}

      {productChosen && (
        <Fragment>
          <Row className="app-row survey-app">
            <Colxx xxs="12">
              <h1>Selected Subscription</h1>
            </Colxx>
          </Row>

          <Separator className="mb-5" />
          {!loading ? (
            <div className="equal-height-container mb-5 row">
              <div className="col-item mb-4 col-md-12 col-lg-4">
                <div className="card">
                  <div className="pt-5 pb-5 d-flex flex-lg-column flex-md-row flex-sm-row flex-column card-body">
                    <div className="price-top-part">
                      <h5 className="mb-0 font-weight-semibold color-theme-1 mb-4">
                        {selectedProduct.name}
                      </h5>
                      <p
                        className="mt-2 text-default"
                        style={{ height: '85px' }}
                      >
                        {selectedProduct.description}
                      </p>
                      {selectedProduct.imageUrl !== '' && (
                        <CardImg
                          top
                          src={
                            selectedProduct.imageUrl
                              ? selectedProduct.imageUrl
                              : ''
                          }
                          alt="Card image cap"
                          className="img-thumbnail border-0 rounded-circle list-thumbnail"
                        />
                      )}

                      <i
                        className="demo-icon simple-icon-check activeSubscription"
                        id="nametip"
                      ></i>
                      {/* <p>
                        <img
                          src={`https://bmbuiassetsprod.blob.core.windows.net/images/pricing/img_${selectedProduct.priceStripeId}.png`}
                          width="117px"
                        />
                      </p> */}
                      {isVoucherEngine === true ? (
                        <p className="text-large mb-2 text-default">
                          {selectedProduct.currency}
                          {selectedProduct.price}
                        </p>
                      ) : (
                        <p>
                          <img
                            src={`https://bmbuiassetsprod.blob.core.windows.net/images/pricing/img_${selectedProduct.priceStripeId}.png`}
                            width="117px"
                          />
                        </p>
                      )}
                    </div>
                    <div className="pl-3 pr-3 pt-3 pb-0 d-flex price-feature-list flex-column flex-grow-1">
                      <ul>
                        {selectedProduct.features.map((feature, index) => {
                          return (
                            <li key={`selectedfeature_item_${index}`}>
                              <p className="mb-0">{feature.name}</p>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="loading" />
          )}

          <Row>
            <Colxx xxs="12" className="mb-2">
              <Button color="primary" size="xs" onClick={Subscribe}>
                Confirm
              </Button>
              <Button
                color="secondary"
                size="xs"
                onClick={Cancel}
                className="ml-2"
              >
                Back
              </Button>
            </Colxx>
          </Row>
        </Fragment>
      )}
    </Fragment>
  );
}

const mapStateToProps = ({ settings }) => {
  const { propertyId, isVoucherEngine } = settings;
  return {
    propertyId,
    isVoucherEngine,
  };
};

export default injectIntl(connect(mapStateToProps, {})(Index));
